var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.8111 0.891804C14.0642 1.14642 14.0629 1.55798 13.8083 1.81104L5.60821 9.96103C5.35414 10.2135 4.94367 10.2129 4.69038 9.95962L0.190381 5.45962C-0.0634602 5.20578 -0.0634602 4.79422 0.190381 4.54038C0.444221 4.28654 0.855779 4.28654 1.10962 4.54038L5.15141 8.58217L12.8919 0.888986C13.1465 0.635925 13.5581 0.637186 13.8111 0.891804Z","fill":"currentColor"}));
}

Check.defaultProps = {"id":"check","viewBox":"0 0 14 11","fill":"none"};

module.exports = Check;

Check.default = Check;
